import { TextArea, type TextAreaProps } from '../inputs/TextArea';
import WithDisplayFormat, { type WithDisplayFormatProps } from '../withDisplayFormat';

export interface TextareaWithDisplayFormatProps extends Omit<WithDisplayFormatProps, 'render'> {}

const TextareaWithDisplayFormat = (props: TextareaWithDisplayFormatProps) => (
  <WithDisplayFormat<TextAreaProps>
    {...props}
    render={(renderProps) => <TextArea {...renderProps} />}
  />
);

export default TextareaWithDisplayFormat;
